import React from "react";
import PropTypes from "prop-types";
import Header from "./header";
import Footer from "./footer";
import "../assets/styles/layout.scss";
import { scrollToHashWhenLoad } from "../utilities/scroll";
import useClientSide from "../hooks/useClientSide";

const Layout = ({
  children,
  isDonationHeader,
  campaignToDonationLink,
  campaignToDonationLinkMonthly,
  cosmosCampaignId,
}) => {
  const isClientSide = useClientSide();
  if(isClientSide) {
    scrollToHashWhenLoad();
  }

  return (
    <>
      <Header
        campaignToDonationLink={campaignToDonationLink}
        campaignToDonationLinkMonthly={campaignToDonationLinkMonthly}
        cosmosCampaignId={cosmosCampaignId}
        isDonationHeader={isDonationHeader}
      />
      <main>{children}</main>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
